import { RoadAccidentsStatusEnum } from '~/shared/config/enums'

export const getStatusColor = (status?: RoadAccidentsStatusEnum) => {
  if (status === RoadAccidentsStatusEnum.OPENED) return 'green'
  if (status === RoadAccidentsStatusEnum.CLOSED) return 'gray'

  return 'gray'
}
